// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__10cMs","radioRow":"SimpleQuestionBuilderModal_radioRow__3QfN7"};